<script>
import AppendToBody from '~/mixins/append_to_body';
import Vue from 'vue';
import Loader from '~/components/loader/components/loader';
import { Dialog } from 'element-ui';

Vue.use(Dialog);

export default {
    name: 'email-preview',

    components: {
        Loader
    },

    mixins: [AppendToBody],

    props: {
        keepUnmatchedPlaceholders: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            isLoading: false,
            isOpen: false,
            comarketer: null,
            loans: null,
            draftType: null,
            video: {
                'video_url': null,
                'thumb_url': null,
                'embedded_url': null
            },
            emailId: null,
            message: null,
            subject: null,
            websiteId: null,
            image_filename: null,
            cleanIframe: null,
            appendStyles: false,
            styles: {
                content: ''
            }
        }
    },

    watch: {
        message(val) {
            this.setIframeContent(val);
        },

        isLoading(val) {
            this.$emit(val ? 'loading' : 'loaded')
        }
    },

    computed: {
        modalHeight() {
            let height = $(window).height() - 400;
            return height >= 500 ? height : 500;
        },

        subjectComputed() {
            return this.isLoading ? 'Loading...' : this.subject;
        }
    },



    methods: {
        getEmail(emailId) {
            this.isLoading = true;

            $.ajax({
                url: `/email/get/${emailId}`,
                method: 'POST',
                global: false,
                data: {
                    message: this.message,
                    subject: this.subject || '(Untitled Message)',
                    comarketer: this.comarketer,
                    video: this.video,
                    loans: this.loans,
                    websiteId: this.websiteId ? this.websiteId : $('.js-email-preview-btn').data("website-id"),
                    keep_unmatched_placeholders: this.keepUnmatchedPlaceholders,
                    append_styles: this.appendStyles
                }
            })
            .done((data) => {
                this.getEmailCallback(data);
            })
            .fail((xhr) => {
                this.isLoading = false;
                buildFlashMessage('Error generating the preview. Please wait a moment and then try again.', 'danger');
            });
        },

        getEmailCallback(data) {
            this.image_filename = data.image_filename;

            if (data.status) {
                this.styles = data.styles;
                this.message = data.message;
            } else {
                this.message = '';
            }

            this.draftType = data.draft_type;
            this.subject = data.subject;
            this.isLoading = false;

            if (!data.status) {
                this.isOpen = false;
                let errorMessage = typeof data.error_message === 'string'
                    ? data.error_message
                    : 'The server encountered an error. Please wait a moment and then try again.';

                buildFlashMessage(`Error: ${errorMessage}`, 'danger');
            }
        },

        open() {
            this.isOpen = true;
        },

        onOpen() {
            this.getEmail(this.emailId);
        },

        setIframeContent(content) {
            this.$nextTick(() => {
                let iframe = this.$el.querySelector('.email-preview-iframe');
                if (!iframe) return;

                if (!this.cleanIframe){
                    // Save off a copy of the iframe before contentWindow gets contaminated. Looking at you, Vimeo.
                    this.cleanIframe = iframe.cloneNode(true);
                }

                // Only change or access iframe.contentWindow.contents if we have content to add to avoid a cross-origin frame SecurityError
                if (content) {
                    content = this.insertStyles(content);
                    iframe.srcdoc = content;

                    if (!this.styles.content || !this.appendStyles) {
                        return;
                    }

                    iframe.contentWindow.document.open('text/html', 'replace');
                    iframe.contentWindow.document.write(content);
                    iframe.contentWindow.document.close();
                }
            });
        },

        insertStyles(content) {
            if (this.styles.content && this.appendStyles) {
                return `
                    ${content}
                    <style>
                        ${this.styles.content}
                    </style>
                `;
            }

            return content;
        },

        resetIframe() {
            let iframe = this.$el.querySelector('.email-preview-iframe');

            if (iframe && this.cleanIframe) {
                // to convince microsoft browsers we aren't trying anything funny.
                iframe.removeAttribute('src');
                let iframeParentNode =  iframe.parentNode;
                iframeParentNode.replaceChild(this.cleanIframe, iframe);
            }
        },

        onClose() {
            Object.assign(this.$data, this.$options.data());
            this.resetIframe();
        }
    }
};
</script>

<template>
    <el-dialog
        :class="{'no-body-padding': !image_filename, 'el-dialog--scroll': !image_filename}"
        :visible.sync="isOpen"
        size="large"
        @open="onOpen"
        @close="onClose"
    >
        <div slot="title" class="el-dialog__title">
            <span v-if="draftType === 'latest'" class="label label-warning">Draft</span>
            <span>{{ subjectComputed }}</span>
        </div>
        <loader :is-loading="isLoading"></loader>
        <iframe
                class="el-dialog-body__scroll-container email-preview-iframe"
                frameborder="0"
                width="100%"
                :height="modalHeight">
        </iframe>
    </el-dialog>
</template>
